import { styled, ThemedColorProps } from "styles";
import {
  display,
  space,
  width,
  maxWidth,
  minWidth,
  flex,
  flexDirection,
  justifyContent,
  alignItems,
  flexWrap,
  alignSelf,
  border,
  SpaceProps,
  WidthProps,
  MaxWidthProps,
  MinWidthProps,
  FlexProps,
  JustifyContentProps,
  AlignItemsProps,
  FlexWrapProps,
  AlignSelfProps,
  BorderProps,
  FlexDirectionProps,
  color,
  borderRadius,
  BorderRadiusProps,
  borders,
  DisplayProps,
  height,
  HeightProps,
} from "styled-system";

type Props = DisplayProps &
  SpaceProps &
  WidthProps &
  MaxWidthProps &
  MinWidthProps &
  FlexProps &
  FlexDirectionProps &
  JustifyContentProps &
  AlignItemsProps &
  FlexWrapProps &
  AlignSelfProps &
  BorderProps &
  ThemedColorProps &
  BorderRadiusProps &
  BorderProps&
  HeightProps;

const View = styled<Props, "div">("div")`
    ${display}
    ${space}
    ${width}
    ${maxWidth}
    ${minWidth}
    ${flex}
    ${flexDirection}
    ${justifyContent}
    ${alignItems}
    ${flexWrap}
    ${alignSelf}
    ${border}
    ${color}
    ${borderRadius}
    ${borders}
    ${height}
  `;
View.defaultProps = {
  display: "flex"
};

export default View;


// WEBPACK FOOTER //
// ./src/components/ui/View.tsx